import { render, staticRenderFns } from "./ReportSubPage.vue?vue&type=template&id=6345a68c&scoped=true&"
import script from "./ReportSubPage.vue?vue&type=script&lang=ts&"
export * from "./ReportSubPage.vue?vue&type=script&lang=ts&"
import style0 from "./ReportSubPage.vue?vue&type=style&index=0&id=6345a68c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6345a68c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VDivider})
